import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Container from "@material-ui/core/Container";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import "../css/resetPass.css";

import { changeAccount } from "./../redux";
import {
  signIn,
  signUp,
  sendResetPasswordEmail,
} from "./../firebaseApi";

import { firebaseConfig } from "../credentials";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

/*
import functions from "firebase-functions";
import admin from "firebase-admin";
import nodemailer from "nodemailer";

admin.initializeApp();*/

export const initFirebase = () => {
  firebase.initializeApp(firebaseConfig);
  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
};

const styles = (theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    marginTop: theme.spacing(15),
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  button: {
    marginTop: theme.spacing(3),
  },
  nameContainer: {
    padding: "0px",
    display: "flex",
    flexDirection: "row",
  },
});

function Login(props) {
  const [resetPasswordEmail, setResetPasswordEmail] = React.useState("");
  const [resetPasswordOpen, setResetPasswordOpen] = React.useState(false);
  const [tab, setTab] = React.useState(0);
  const [values, setValues] = React.useState({
    email: "",
    password: "",
    repeatPassword: "",
    firstName: "",
    lastName: "",
    // identifier: "",
  });
  const [errors, setErrors] = React.useState({
    email: "",
    password: "",
    repeatPassword: "",
    firstName: "",
    lastName: "",
  });
  const [successMessage, setSuccessMessage] = React.useState("");

  function clearFields() {
    setValues({
      email: "",
      password: "",
      repeatPassword: "",
      firstName: "",
      lastName: "",
      // identifier: "",
    });
    setErrors({
      email: "",
      password: "",
      repeatPassword: "",
      firstName: "",
      lastName: "",
    });
  }

  /*
  async function sendErrorEmail(errorMessage) {
    const transporter = nodemailer.createTransport({
      service: "gmail",
      auth: {
        user: functions.config().gmail.email,
        pass: functions.config().gmail.password,
      },
    });

    const mailOptions = {
      from: `WebClicker <weblicker.ucsd@gmail.com>`,
      to: "a3.alani@gmail.com",
      subject: "Error occurred in WebClicker",
      text: errorMessage,
    };

    return await transporter.sendMail(mailOptions);
  }
  */

  async function validateFields() {
    let validated = true;
    let errorsCopy = { ...errors };

    if (tab === 0) {
      if (values.email.length === 0) {
        errorsCopy.email = "Email cannot be empty";
        validated = false;
      } else {
        errorsCopy.email = "";
      }
      try {
        await firebase
          .auth()
          .signInWithEmailAndPassword(values.email, values.password);
      } catch (error) {
        errorsCopy.email = "Invalid Email or Password";
        validated = false;
      }

      if (values.password.length === 0) {
        errorsCopy.password = "Password cannot be empty";
        validated = false;
      } else {
        errorsCopy.password = "";
      }
    } else if (tab === 1) {
      if (values.email.length === 0) {
        errorsCopy.email = "Email cannot be empty";
        validated = false;
      }

      try {
        const signInMethods = await firebase
          .auth()
          .fetchSignInMethodsForEmail(values.email);
        if (signInMethods.includes("password")) {
          errorsCopy.email =
            "The email address you entered is already associated with an account. Please log in to that account, or enter a different email address to create a new account.";
          validated = false;
        } else {
          errorsCopy.email = "";
        }
      } catch (error) {
        //alert(error);
      }

      if (values.password !== values.repeatPassword) {
        errorsCopy.repeatPassword = "Password does not match";
        validated = false;
      } else {
        errorsCopy.repeatPassword = "";
      }
      if (values.password.length === 0) {
        errorsCopy.password = "Password cannot be empty";
        validated = false;
      } else if (values.password.length < 6) {
        errorsCopy.password = "Password must be at least 6 characters";
        validated = false;
      } else {
        errorsCopy.password = "";
      }

      if (values.firstName.trim().length === 0) {
        errorsCopy.firstName = "First name cannot be empty";
        validated = false;
      } else {
        errorsCopy.firstName = "";
      }

      if (values.lastName.trim().length === 0) {
        errorsCopy.lastName = "Last name cannot be empty";
        validated = false;
      } else {
        errorsCopy.lastName = "";
      }
    }
    setErrors(errorsCopy);
    return validated;
    /*
    try {
      setErrors(errorsCopy);
    } catch (error) {
      // Send email here
      alert("An unspecified error occurred");
      sendErrorEmail(error);
    }
    */
  }

  return (
    <Paper className={props.classes.paper}>
      <Tabs
        value={tab}
        centered
        onChange={(event, newValue) => {
          setTab(newValue);
          clearFields();
        }}
      >
        <Tab label="Sign In" />
        <Tab label="Sign Up" />
      </Tabs>

      <TextField
        fullWidth
        margin="normal"
        type="email"
        label="Email address"
        value={values.email}
        error={errors.email.length > 0}
        helperText={errors.email}
        onChange={(event) => {
          setValues({ ...values, email: event.target.value });
        }}
      />

      <TextField
        fullWidth
        margin="normal"
        type="password"
        label="Password"
        value={values.password}
        error={errors.password.length > 0}
        helperText={errors.password}
        onChange={(event) => {
          setValues({ ...values, password: event.target.value });
        }}
      />

      {tab === 0 ? null : (
        <>
          <TextField
            fullWidth
            margin="normal"
            type="password"
            label="Repeat password"
            value={values.repeatPassword}
            error={errors.repeatPassword.length > 0}
            helperText={errors.repeatPassword}
            onChange={(event) => {
              setValues({ ...values, repeatPassword: event.target.value });
            }}
          />

          <Container className={props.classes.nameContainer}>
            <TextField
              fullWidth
              margin="normal"
              label="First name"
              error={errors.firstName.length > 0}
              helperText={errors.firstName}
              onChange={(event) => {
                setValues({ ...values, firstName: event.target.value });
              }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Last name"
              error={errors.lastName.length > 0}
              helperText={errors.lastName}
              onChange={(event) => {
                setValues({ ...values, lastName: event.target.value });
              }}
            />
          </Container>

          {/* <TextField
            fullWidth
            margin="normal"
            label="Student identifier"
            value={values.identifier}
            helperText="eg. Student ID, PID, etc"
            onChange={(event) => {
              setValues({ ...values, identifier: event.target.value });
            }}
          /> */}
        </>
      )}

      <Button
        className={props.classes.button}
        fullWidth
        variant="outlined"
        onClick={async () => {
          if (
            validateFields() &&
            values.firstName.trim().length > 0 &&
            values.lastName.trim().length > 0 &&
            values.repeatPassword === values.password
          ) {
            // let { email, password, firstName, lastName, identifier } = values;
            let { email, password, firstName, lastName } = values;
            try {
              email = email.toLowerCase();
              if (tab === 0) {
                let data = {
                  email,
                  password,
                };
                signIn(data).then((accountDetails) => {
                  props.changeAccount(accountDetails);
                  props.history.push("/loading");
                });
              } else {
                let data = {
                  email,
                  password,
                  firstName,
                  lastName,
                  // identifier,
                  type: "student",
                };
                signUp(data).then((accountDetails) => {
                  props.changeAccount(accountDetails);
                  props.history.push("/loading");
                });
              }
            } catch (e) {
              //console.error(e);
            }
          }
        }}
      >
        {tab === 0 ? "Sign in" : "Sign Up"}
      </Button>

      {tab === 0 ? (
        <Button
          className={props.classes.button}
          fullWidth
          variant="outlined"
          onClick={() => setResetPasswordOpen(true)}
        >
          {"Reset Password"}
        </Button>
      ) : null}

      <Dialog open={resetPasswordOpen}>
        <DialogTitle>Reset Password</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the email for which you'd like to reset your password. If a
            user exists with this email, a password reset link will be sent.
          </DialogContentText>
          <TextField
            fullWidth
            margin="normal"
            label="Email"
            value={resetPasswordEmail}
            onChange={(event) => {
              setResetPasswordEmail(event.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setResetPasswordOpen(false);
              setResetPasswordEmail("");
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              // console.log(resetPasswordEmail);
              sendResetPasswordEmail({ email: resetPasswordEmail })
                .then((message) => {
                  setSuccessMessage(message);
                  setResetPasswordOpen(false);
                  setResetPasswordEmail("");
                  setTimeout(() => {
                    setSuccessMessage("");
                  }, 7500);
                })
                .catch((error) => {
                  alert(error);
                });
            }}
          >
            Reset
          </Button>
        </DialogActions>
      </Dialog>
      {successMessage && (
        <div className="success-message">
          <p>{successMessage}</p>
          <Button
            className="close-button"
            onClick={() => {
              setSuccessMessage("");
            }}
          >
            <CloseIcon />
          </Button>
        </div>
      )}
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAccount: (data) => dispatch(changeAccount(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(Login))));
